import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import _ from 'lodash';
import dayjs from 'dayjs';
import Yup from '../../../utils/yup';
import utc from 'dayjs/plugin/utc';

import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import useMenus from '../../../context/MenuContext';
import masterDataService from '../../../service/masterData.service';
import useUsers from '../../../context/UsersContext';
import resourceTwoService from '../../../service/resources/resourceTwo.service';

import { DeleteDialogUI, FormBase, FormButtonPanelUI, FormHeaderUI } from '../../Interface';
import ResourceTwoReports from './ResourceTwoReports';
import { ResourceTwoFields } from './ResourceTwoFields';
import propertyService from '../../../service/property.service';
import { cleanValues, generateAutocompleteItems, getJokerFieldType } from '../../../utils/helper';
import ResoureTwoTabs from './ResoureTwoTabs';
import { getDynVals } from '../../../utils/DynHelper';
import jokerService from '../../../service/joker.service';
import { JokerFieldTypes, JokerTypes } from '../../../config/joker';

export const ResourceTwoPage = () => {
  const { menus, getMenus, getMenuSubMenuId, getCanEdit } = useMenus();
  const { getUser, user } = useUsers();
  const [refetchTable, setRefetchTable] = useState(true);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [dynProps, setDynProps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dynLoading, setDynLoading] = useState(true);
  const isLoading = loading || dynLoading;
  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    type: [],
    status: [],
    resourceGroup: [],
  });

  const [defaultValues, setDefaultValues] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  const [initValues, setInitValues] = useState({});
  const [autocompleteData, setAutocompleteData] = useState({});
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [submenu, setSubmenu] = useState(null);
  const [propertyGroups, setPropertyGroups] = useState([]);
  const [group, setGroup] = useState({
    id: [],
  });
  const [jokerFields, setJokerFields] = useState([]);
  const [jokerLoading, setJokerLoading] = useState(true);

  const getJokerFields = () => {
    jokerService
      .getFields(JokerTypes.RESOURCETWO)
      .then((data) => {
        setJokerFields(data);
      })
      .finally(() => {
        setJokerLoading(false);
      });
  };

  useEffect(() => {
    getMenus();
    if (!Object.keys(user).length) getUser();
    getJokerFields();

    const def = {
      name: '',
      groupId: null,
      active: true,
      statusId: null,
      typeId: null,
      joker_char1: '',
      joker_char2: '',
      joker_char3: '',
      joker_char4: '',
      joker_char5: '',
      joker_char6: '',
      joker_char7: '',
      joker_char8: '',
      joker_char9: '',
      joker_char10: '',
      joker_date1: null,
      joker_date2: null,
      joker_date3: null,
      joker_date4: null,
      joker_date5: null,
      joker_num1: '',
      joker_num2: '',
      joker_num3: '',
      joker_num4: '',
      joker_num5: '',
      joker_int1: '',
      joker_int2: '',
      joker_int3: '',
      joker_int4: '',
      joker_int5: '',
    };

    setDefaultValues(def);
  }, []);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          statusId: autocompleteData?.status?.defaultValue ?? null,
          typeId: autocompleteData?.type?.defaultValue ?? null,
          groupId: autocompleteData?.resourceGroup?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          status: autocompleteData?.status?.defItem,
          type: autocompleteData?.type?.defItem,
          resourceGroup: autocompleteData?.resourceGroup?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('resourceTwo');
    setSubmenu(submenuId);
    setCanEdit(getCanEdit(submenuId));
  }, [menus]);

  useEffect(() => {
    if (submenu) {
      initDefaultValues();
      getPropertyGroupsForForm();
    }
  }, [submenu]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!_.isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  const getPropertyGroupsForForm = () => {
    propertyService.getPropertyGroupsForSubmenus({ data: [submenu] }).then((data) => {
      setPropertyGroups(data);
    });
  };

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .typeToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .groupToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          type: resp[0],
          status: resp[1],
          resourceGroup: resp[2],
        };
        setAutocompleteData(aData);

        const acOptions = {
          type: generateAutocompleteItems(aData.type.typeItems, 'itemName', 'itemId'),
          status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
          resourceGroup: generateAutocompleteItems(aData.resourceGroup.projectGroupListitems, 'itemName', 'itemId'),
        };
        setAutoCompleteOptions(acOptions);
        setLoading(false);
      })
      .finally(() => {
        //hideLoader();
      });
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    groupId: Yup.string().nullable(),
    active: Yup.boolean(),
    statusId: Yup.string().nullable(),
    typeId: Yup.string().nullable(),
    ...(jokerFields.length > 0
      ? Object.fromEntries(
          jokerFields.map((field) => {
            const fieldType = getJokerFieldType(field);
            return [
              field.field,
              fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
            ];
          })
        )
      : {}),
  });

  const valuesToForm = () => {
    const {
      name,
      groupId,
      active,
      statusId,
      typeId,
      joker_char1,
      joker_char2,
      joker_char3,
      joker_char4,
      joker_char5,
      joker_char6,
      joker_char7,
      joker_char8,
      joker_char9,
      joker_char10,
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1,
      joker_num2,
      joker_num3,
      joker_num4,
      joker_num5,
      joker_int1,
      joker_int2,
      joker_int3,
      joker_int4,
      joker_int5,
    } = selectedValues;

    setInitValues({
      name,
      groupId,
      active,
      statusId,
      dynamicFields: getDynVals(dynProps, selectedValues.dynamicProperties),
      typeId,
      joker_char1: joker_char1 ?? '',
      joker_char2: joker_char2 ?? '',
      joker_char3: joker_char3 ?? '',
      joker_char4: joker_char4 ?? '',
      joker_char5: joker_char5 ?? '',
      joker_char6: joker_char6 ?? '',
      joker_char7: joker_char7 ?? '',
      joker_char8: joker_char8 ?? '',
      joker_char9: joker_char9 ?? '',
      joker_char10: joker_char10 ?? '',
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1: joker_num1 ?? '',
      joker_num2: joker_num2 ?? '',
      joker_num3: joker_num3 ?? '',
      joker_num4: joker_num4 ?? '',
      joker_num5: joker_num5 ?? '',
      joker_int1: joker_int1 ?? '',
      joker_int2: joker_int2 ?? '',
      joker_int3: joker_int3 ?? '',
      joker_int4: joker_int4 ?? '',
      joker_int5: joker_int5 ?? '',
    });
  };

  const handleSubmit = (values, { resetForm }) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField) {
      handleInsertObject(values, resetForm);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...cleanValues(values),
      updatedBy: user.userId,
    };

    resourceTwoService.updateResource(updData, selectedValues.id).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });
      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);
      setSelectedValues(data);
    });
  };

  const handleInsertObject = async (values, resetForm) => {
    const insertObject = {
      ...cleanValues(values),
      createdBy: user.userId,
    };

    resourceTwoService
      .createResource(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });
        setSelectedValues(data);
        setRefetchTable(true);
        setAddField(true);
        setViewField(true);
      })
      .finally(() => {
        //@TODO loader
      });
  };

  dayjs.extend(utc);

  const handleRemoveElement = async () => {
    const deleteData = {
      deletedBy: user.userId,
    };
    resourceTwoService.deleteResource(deleteData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues(defaultSelectedValues);
    });
  };

  const handleTemplate = () => {
    resourceTwoService.getExcelTemplate().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleExport = () => {
    resourceTwoService.getExcelData().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleImport = (files) => {
    resourceTwoService.importExcel(files, user.userId).then(() => {
      setRefetchTable(true);
      addNotification({
        content: 'Az import sikeres!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  return (
    <>
      <FormBase
        name="ResourceTwo"
        leftPanelContent={
          <>
            <div className="h-full overflow-auto custom-scrollbar">
              <FormHeaderUI
                addClick={() => {
                  setSelectedValues(defaultSelectedValues);
                  setViewField(false);
                  setAddField(false);
                }}
                addDisabled={!viewField || !canEdit}
                modClick={() => {
                  setViewField(false);
                  setEditButtonvisible(false);
                }}
                modDisabled={!viewField || operatorsDisabled || !canEdit}
                deleteClick={() => {
                  setShowDeleteDialog(true);
                }}
                deleteDisabled={!viewField || operatorsDisabled || !canEdit}
                copyClick={() => {
                  setViewField(false);
                  setAddField(false);
                }}
                copyDisabled={!viewField || operatorsDisabled || !canEdit}
              />

              <Formik
                initialValues={initValues}
                validationSchema={validationSchema}
                validateOnChange={false}
                onSubmit={handleSubmit}
                enableReinitialize
                //validateOnMount={false}
              >
                {({ values, setFieldValue, errors, validateField, resetForm }) => (
                  <Form>
                    <ResourceTwoFields
                      viewField={viewField}
                      submenuId={submenu}
                      selectedValues={selectedValues}
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                      validateField={validateField}
                    />
                    {!jokerLoading && (
                      <ResoureTwoTabs
                        disabled={viewField}
                        submenuId={submenu}
                        setFieldValue={setFieldValue}
                        selectedValues={selectedValues}
                        setDefaultValues={setDefaultValues}
                        dynProperties={{ dynProps, setDynProps }}
                        user={user}
                        setRefetchTable={setRefetchTable}
                        propertyGroups={propertyGroups}
                        groupState={{ group, setGroup }}
                        dynLoadingState={{ dynLoading, setDynLoading }}
                        setSelectedValues={setSelectedValues}
                        handleImport={handleImport}
                        handleExport={handleExport}
                        handleTemplate={handleTemplate}
                      />
                    )}
                    <FormButtonPanelUI
                      onCancelClick={() => {
                        setViewField(true);
                        setEditButtonvisible(true);
                        setAddField(true);

                        resetForm();
                      }}
                      disabled={editButtonVisible && addField}
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </>
        }
        rightPanelContent={
          !isLoading && (
            <ResourceTwoReports
              refetch={{ refetchTable, setRefetchTable }}
              values={{ selectedValues, setSelectedValues }}
              viewField={viewField}
              operatorsDisabled={operatorsDisabled}
              autocompleteOptions={autocompleteOptions}
              dynProps={dynProps}
              jokerFields={jokerFields}
            />
          )
        }
      />
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />
    </>
  );
};
